import React, { useEffect, useState } from "react";
import "../../styles/Payouts.css";
import Header from "../../components/Header/Header.js";
import Balance from "../../assets/Images/Balance.svg";
import withdraw from "../../assets/Images/withdrawamount.svg";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { GetWebAccessToken } from "../../components/ReusebleComponents/ResuseableApiCalls";
import "../../CommonStyle/Tablestyling.css";
import { Select, MenuItem } from "@mui/material";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { data } from "../../Common/Text/NormalText.js";
import { useSelector } from "react-redux";

const ProPartnerPayOuts = () => {
  const [selectedTab, setSelectedTab] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const recordsPerPageOptions = [5, 10, 25, 50];
  const [withdrawTransaction, setWithdrawTransaction] = useState({
    paymentsHistory: [],
    distributorsCount: 0,
    withdrawAmount: 0,
    revenue: 0,
  });
  const navigate = useNavigate();
    const userDetails = useSelector((state) => state?.user?.user);

  const baseUrl = process.env.REACT_APP_BACKEND_URL;

  const fetchProPartnerAnalytics = async () => {
    const token = await GetWebAccessToken();
    try {
      const Headers = {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
    "Pragma": "no-cache",
        Authorization: `Bearer ${token}`,
      };
      const response = await axios.get(
        `${baseUrl}/refer/proPartner/analytics`,
        {
          headers: Headers,
        }
      );

      const responseData = response.data;
      console.log("responseData in pro partner", responseData);
      if (responseData?.status) {
        setWithdrawTransaction((prev) => ({
          ...prev,
          paymentsHistory: responseData?.data,
          revenue: Number(responseData?.totalRevenue)?.toFixed(2),
          withdrawAmount: Number(responseData?.totalWithdraw),
          distributorsCount: Number(responseData?.distributors),
          totalPayments: Number(responseData?.totalPayments),
        }));
      }
    } catch (err) {
      console.log("some thing went wrong", err);
    }
  };

  useEffect(() => {
    fetchProPartnerAnalytics();
  }, []);

  const formatNumber = (num) => {
    console.log("number to format:", num, typeof num);
    if(num === null || num === undefined || isNaN(num)) return "0";
    if (num >= 1000000) {
      return (num / 1000000).toFixed(2) + "M";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2) + "k";
    }
    return num;
  };

  const filteredData = withdrawTransaction.paymentsHistory.filter(
    (transaction) => {
      return (
        transaction?.transactionId
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        transaction?.beneficiaryName
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        transaction?.payOutAccountNumber
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ||
        transaction?.status?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handlePrevNext = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }


  return (
    <div className="Payouts">
      <Header title="Pro-Partner Payout's Dashboard" />
      <div className="inside-bg-analytics">
        <div className="dash-grids-payouts">
          <div className="revenue-sideline-payouts">
            <div className="stats-grid-payouts">
              <div className="stat-card-1-payouts">
                <div className="stat-header-payouts">
                  <img src={Balance} />
                  <h3>{data?.Balance}</h3>
                </div>
                <hr className="gradient-line-payouts" />
                <div className="values-full-div-payouts-firstbox-container-v">
                  <div className="values-full-div-payouts-firstbox">
                    <div className="stat-value-payouts">
                      ₹ {formatNumber(withdrawTransaction?.revenue)}
                    </div>
                    <span className="trend positive-payouts">
                      {formatNumber(withdrawTransaction?.distributorsCount)}{" "}
                      {data?.no}
                    </span>
                    <p className="stat-period-payouts">Distributors Count</p>
                  </div>
                  <div>
                    <button
                      disabled={Number(withdrawTransaction?.revenue) < 25000 || !userDetails?.proPartnerWithdrawStatus}
                      title={
                        Number(withdrawTransaction?.revenue) < 25000
                          ? "withdraw amount should be greater than 25,000 Rs"
                          : ""
                      }
                      onClick={() => {
                        if (Number(withdrawTransaction?.revenue) > 25000) {
                          navigate("/ProPartnerWithDrawAmount", {
                            state: {
                              availableWalletAmount:
                                Number(withdrawTransaction?.revenue),
                              withdrawAmount:
                                Number(withdrawTransaction?.withdrawAmount),
                              distributorsCount:
                                Number(withdrawTransaction?.distributorsCount),
                            },
                          });
                        }
                      }}
                      className="withdraw-btn-payouts"
                    >
                      {data?.with}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="small-vertical-line-payouts"></div>
            <div className="stats-grid-payouts">
              <div className="stat-card-1-payouts">
                <div className="stat-header-payouts">
                  <img src={withdraw} />
                  <h3>{data?.withdraw}</h3>
                </div>
                <hr className="gradient-line-payouts" />
                <div className="values-full-div-payouts">
                  <div className="stat-value-payouts">
                    ₹ {formatNumber(withdrawTransaction?.withdrawAmount)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="tabs-container-payouts">
          <button
            className={`tab-button ${selectedTab === "All" ? "active" : ""}`}
            onClick={() => setSelectedTab("All")}
          >
            {data?.all}
          </button>
        </div>

        <div className="payments-section-payouts">
          <div className="section-header-payouts">
            <div className="search-container">
              <SearchIcon
                style={{ color: "var(--thirdshade-orange)" }}
                className="search-icon"
              />
              <input
                type="text"
                value={searchQuery}
                placeholder="Search here"
                className="search"
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="table-actions-payouts"></div>
          </div>
          <div className="tabs-table-container-payouts">
            <div className="common-table-v">
              <table>
                <thead className="PO-table-header">
                  <tr>
                    <th style={{ textAlign: "left" }} className="PO-each-th">
                      {data?.tID}
                    </th>
                    <th className="PO-each-th">{data?.AccountName}</th>
                    <th className="PO-each-th">{data?.AccountNo}</th>
                    <th className="PO-each-th">{data?.ifsc}</th>
                    <th className="PO-each-th">{data?.withdraw}</th>
                    <th className="PO-each-th">{data?.tds}</th>
                    <th className="PO-each-th">{data?.cr}</th>
                    <th className="PO-each-th">{data?.Date}</th>
                    <th className="PO-each-th">{data?.status}</th>
                  </tr>
                </thead>
                <tbody>
                  {currentData?.length > 0 &&
                    currentData?.map((eachTrnx, trnxIndex) => {
                      const dateParts = eachTrnx?.transactionDate?.split("/");
                      const formattedDate =
                        dateParts && dateParts.length === 3
                          ? `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`
                          : "N/A";

                      const timeParts = eachTrnx?.transactionTime
                        ? eachTrnx?.transactionTime.split(" ")
                        : null;
                      const formattedTime = timeParts
                        ? timeParts[0] + " " + timeParts[1]
                        : "N/A";

                      const creditedAmount =
                        isNaN(parseFloat(eachTrnx?.actualAmount)) ||
                        isNaN(parseFloat(eachTrnx?.TDSCharges))
                          ? "N/A"
                          : (
                              parseFloat(eachTrnx?.actualAmount) -
                              parseFloat(eachTrnx?.TDSCharges)
                            ).toFixed(2);

                      return (
                        <tr className="PO-table-tr" key={trnxIndex}>
                          <td
                            className="PO-each-td truncated-text"
                            title={eachTrnx?.transactionId}
                          >
                            {eachTrnx?.transactionId?.slice(0, 14)}...
                          </td>
                          <td className="PO-each-td">
                            {eachTrnx?.beneficiaryName || "N/A"}
                          </td>
                          <td className="PO-each-td">
                            {eachTrnx?.payOutAccountNumber || "N/A"}
                          </td>
                          <td className="PO-each-td">
                            {eachTrnx?.payOutIFSCNumber || "N/A"}
                          </td>
                          <td className="PO-each-td">
                            {isNaN(parseFloat(eachTrnx?.actualAmount))
                              ? "N/A"
                              : parseFloat(eachTrnx?.actualAmount).toFixed(2)}
                          </td>
                          <td className="PO-each-td">
                            {eachTrnx?.TDSPercentage
                              ? `${eachTrnx?.TDSPercentage} %`
                              : "N/A"}
                          </td>
                          <td className="PO-each-td">{creditedAmount}</td>
                          <td className="PO-each-td">
                            {formattedDate} - {formattedTime}
                          </td>
                          <td className="status-PO-each-td">
                            <span
                              className={`status-${
                                eachTrnx?.payOutStatus?.toLowerCase() ===
                                "success"
                                  ? "success"
                                  : eachTrnx?.status?.toLowerCase() ===
                                    "processing"
                                  ? "processing"
                                  : ""
                              }`}
                            >
                              {eachTrnx?.payOutStatus || "N/A"}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
            {filteredData.length > 0 && (
              <div className="pagination-controls">
                <div>
                  <Select
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(e.target.value);
                      setCurrentPage(1);
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="itemsperpage"
                  >
                    {recordsPerPageOptions.map((option) => (
                      <MenuItem key={option} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <button
                    disabled={currentPage === 1}
                    onClick={() => handlePrevNext(Math.max(1, currentPage - 1))}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: currentPage === 1 ? "not-allowed" : "pointer",
                      opacity: currentPage === 1 ? 0.5 : 1,
                    }}
                  >
                    <NavigateBeforeIcon sx={{ fontSize: 18 }} />
                  </button>

                  {pageNumbers.map((page) => (
                    <button
                      key={page}
                      onClick={() => handlePageChange(page)}
                      style={{
                        padding: "6px 12px",
                        borderRadius: "8px",
                        border: "none",
                        backgroundColor:
                          currentPage === page
                            ? "rgba(0, 123, 255, 0.2)"
                            : "#ccc",
                        color: currentPage === page ? "#000" : "#fff",
                        fontWeight: currentPage === page ? "bold" : "normal",
                        cursor: "pointer",
                      }}
                    >
                      {page}
                    </button>
                  ))}

                  <button
                    disabled={currentPage === totalPages}
                    onClick={() =>
                      handlePrevNext(Math.min(totalPages, currentPage + 1))
                    }
                    style={{
                      background: "none",
                      border: "none",
                      cursor:
                        currentPage === totalPages ? "not-allowed" : "pointer",
                      opacity: currentPage === totalPages ? 0.5 : 1,
                    }}
                  >
                    <NavigateNextIcon sx={{ fontSize: 18 }} />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProPartnerPayOuts;
